export const isDeviationValueNegative = (deviationValue?: number | null) => (deviationValue ?? 0) < 0

export const isDeviationPercentageNegative = (deviationPercentage?: number | null) => (deviationPercentage ?? 0) < 0
